// extracted by mini-css-extract-plugin
export default {"holidays":"ServiceHolidays_holidays__IgR40","nowrap":"ServiceHolidays_nowrap__KsMCY"};